import * as React from "react";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";
const PriorityHighIcon = (props) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <G clipPath="url(#clip0_8103_16166)">
            <Path d="M8.0013 14.0007C8.73768 14.0007 9.33464 13.4037 9.33464 12.6673C9.33464 11.9309 8.73768 11.334 8.0013 11.334C7.26492 11.334 6.66797 11.9309 6.66797 12.6673C6.66797 13.4037 7.26492 14.0007 8.0013 14.0007Z" fill={props?.customColor ?? "#FB8603"} />
            <Path d="M6.66797 2H9.33464V10H6.66797V2Z" fill={props?.customColor ?? "#FB8603"} />
        </G>
        <Defs>
            <ClipPath id="clip0_8103_16166">
                <Rect width="16" height="16" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default PriorityHighIcon;
